var map = {
	"./1/5.jpg": 8762,
	"./2/5.jpg": 6363,
	"./3/5.jpg": 7519,
	"./4/5.jpg": 5530,
	"./5/5.jpg": 6431,
	"./6/5.jpg": 2767,
	"./7/5.jpg": 2539,
	"./8/5.jpg": 6793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6140;